import { CaMeetingRequestContext, CaResult } from '../core';

export interface CaAnalysisDialogState {
    minimized?: boolean;
    statuses: string[];
    transcriptStatus: 'grey' | 'green';
    meetingRequestContext?: CaMeetingRequestContext;
    result?: CaResult;
}

export const defaultState = (): CaAnalysisDialogState => ({
    statuses: [],
    transcriptStatus: 'grey',
});
